import React, { useEffect } from 'react';
import { Form as AntForm, Row, Col, Button } from 'antd';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { useTranslation } from 'react-i18next';

import { formFields } from '../../../constants';
import { LabeledInput } from '../../common';

import style from './MapLatLong.module.scss';

// Configure the default icon
const DefaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconAnchor: [ 12, 41 ] // Adjust anchor point if needed
});

L.Marker.prototype.options.icon = DefaultIcon;

const LocationPicker = ({ formik, autoLocate }) => {


  const map = useMapEvents({
    click: e => {
      const { lat, lng } = e.latlng;
      formik.setValues({
        ...formik.values,
        [formFields.LATITUDE]: lat.toFixed(4),
        [formFields.LONGITUDE]: lng.toFixed(4)
      });
      map.flyTo(e.latlng, map.getZoom());
    }
  });
  const handleLocate = () => {
    // Use the browser's geolocation API to get the current location
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          formik.setValues({
            ...formik.values,
            [formFields.LATITUDE]: latitude.toFixed(4),
            [formFields.LONGITUDE]: longitude.toFixed(4)
          });
          const latlng = L.latLng(latitude, longitude);
          map.setView(latlng, map.getZoom()); // Center the map to the current location
          // L.marker(latlng).addTo(map); // Optionally add a marker
          map.flyTo(latlng, map.getZoom());
        },
        error => {
          console.error('Error getting location:', error);
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  };

  useEffect(() => {
    if ('geolocation' in navigator && autoLocate) {
      navigator.geolocation.getCurrentPosition(
        location => {
          const { latitude, longitude } = location.coords;
          formik.setValues({
            ...formik.values,
            [formFields.LATITUDE]: latitude.toFixed(4),
            [formFields.LONGITUDE]: longitude.toFixed(4)
          });
          const latlng = L.latLng(latitude, longitude);

          map.flyTo(latlng, map.getZoom());
        },
      );
    }
  }
  , []);

  return (
    <Button
      data-testid="locationButton"
      icon="environment"
      className={ `leaflet-control leaflet-bar ${style.locationButton}` }
      onClick={ handleLocate }
    />
  );

};

export const MapLatLong = ({ formik, isVisible = true, autoLocate = true, isTesting = false, disabled = false }) => {
  const [ t ] = useTranslation();

  // to prevent set the map to the initial location
  if (!isVisible) {
    return null;
  }

  return (
    <>
      <Row gutter={ 32 }>
        <Col span={ 12 }>
          <AntForm.Item
            key={ formFields.LATITUDE }
            help={ formik.touched[formFields.LATITUDE] && formik.errors[formFields.LATITUDE] }
          >
            <LabeledInput
              label={ t('fields.latitude.label') }
              id={ formFields.LATITUDE }
              value={ formik.values[formFields.LATITUDE] }
              onChange={ formik.handleChange }
              withAsterisks
              disabled={ disabled }
            />
          </AntForm.Item>
        </Col>
        <Col span={ 12 }>
          <AntForm.Item
            key={ formFields.LONGITUDE }
            help={ formik.touched[formFields.LONGITUDE] && formik.errors[formFields.LONGITUDE] }
          >
            <LabeledInput
              label={ t('fields.longitude.label') }
              id={ formFields.LONGITUDE }
              value={ formik.values[formFields.LONGITUDE] }
              onChange={ formik.handleChange }
              withAsterisks
              disabled={ disabled }
            />
          </AntForm.Item>
        </Col>
      </Row>
      <Row>
        <MapContainer
          data-testid="map"
          center={ [
            formik.values[formFields.LATITUDE] ?? 24.7136,
            formik.values[formFields.LONGITUDE] ?? 46.6753
          ] }
          zoom={ 13 }
          style={{ height: '400px', width: '100%' }}
          attributionControl={ false }
          dragging={ disabled }
          touchZoom={ disabled }
          scrollWheelZoom={ disabled }
          doubleClickZoom={ disabled }
          boxZoom={ disabled }
          keyboard={ disabled }
        >

          {/* OpenStreetMap Tiles */}
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />

          {/* Display Marker */}
          {!isTesting && (
            <Marker
              position={ [
              formik.values[formFields.LATITUDE] ?? 24.7136,
              formik.values[formFields.LONGITUDE] ?? 46.6753
              ] }
            />
)}

          {/* Handle map clicks */}
          {!disabled && <LocationPicker formik={ formik } autoLocate={ autoLocate } />}
        </MapContainer>
      </Row>
    </>
  );
};

